import types from './types';

/**
 * Type defs
 *
 * Menu object returned from API
 * @typedef {Object} Menu
 * @property {Entity[]} entities - who this menu is applied to
 * @property {String} formattedDate - date of menu in M-DD-YYYY format
 * @property {Meal[]} meals - meals that make up this menu
 * @property {String} menuDate - iso date of menu
 * @property {Number} menuId - id of menu
 * @property {String} menuName - name of menu
 * @property {String} menuType - type of menu depending on its entities (room or center)
 * @property {String} note - note attached to a menu
 *
 * Who a menu is applied to
 * @typedef {Object} Entity
 * @property {Number} id - id of entity
 * @property {String} type - type of entity (room or center)
 * @property {String} name - name of entity
 *
 * A meal
 * @typedef {Object} Meal
 * @property {String[]} foods - foods that make up this meal
 * @property {String} formattedMealtime - formatted mealtime
 * @property {String} mealtime - mealtime. can be: 'breakfast', 'am_snack', 'lunch', or 'pm_snack'
 */

/**
 * Request to get menus
 */
const getMenusRequest = () => ({
  type: types.GET_MENUS_REQUEST
});

/**
 * Successful menus request
 * @param {Menu[]} menus
 */
const getMenusSuccess = menus => ({
  type: types.GET_MENUS_SUCCESS,
  menus
});

/**
 * Unsuccessful menus request
 * @param {Error} error
 */
const getMenusFailure = error => ({
  type: types.GET_MENUS_FAILURE,
  error
});

/**
 * Request to copy and existing menu
 * @param {Object} menuToCopy
 * @param {Object[]} datesToCopyTo
 */
const copyMenuRequest = (menuToCopy, datesToCopyTo) => ({
  type: types.COPY_MENU_REQUEST,
  menuToCopy,
  datesToCopyTo
});

/**
 * Successful menu copy
 */
const copyMenuSuccess = () => ({
  type: types.COPY_MENU_SUCCESS
});

/**
 * Unsuccuessful menu copy
 */
const copyMenuFailure = () => ({
  type: types.COPY_MENU_FAILURE
});

/**
 * Archive a menu
 * @param {Number} menuId
 */
const archiveMenuRequest = menuId => ({
  type: types.ARCHIVE_MENU_REQUEST,
  menuId
});

const archiveMenuSuccess = menuId => ({
  type: types.ARCHIVE_MENU_SUCCESS,
  menuId
});

const archiveMenuFailure = () => ({
  type: types.ARCHIVE_MENU_FAILURE
});

const printCurrentMonthRequest = () => ({
  type: types.PRINT_MENUS_FOR_CURRENT_MONTH
});

export default {
  getMenusRequest,
  getMenusSuccess,
  getMenusFailure,
  copyMenuRequest,
  copyMenuSuccess,
  copyMenuFailure,
  archiveMenuRequest,
  archiveMenuSuccess,
  archiveMenuFailure,
  printCurrentMonthRequest
};
